<template>
    <div name="proof" class="proof">
        <div class="inner-div-proof">
            <span class="title">쉽고 간편한 솔닥<br/>고객 만족도가 증명합니다</span>
            <span class="sub-title"><span>1) 2023년 3월 기준, 솔닥 고객 만족도 조사</span><span>2) 2023년 3월 31일 기준</span></span>
            <div class="img-list">
                <div class="img-wrapper1">
                    <img class="image" src="../../assets/renew_pc/p-image-1.png" alt="NPS 순수 고객 추천 94% 1)"/>
                    <img class="text-image" src="../../assets/renew_pc/t1.png" alt="NPS 순수 고객 추천 94% 1)"/>
                </div>
                <div class="img-wrapper2">
                    <img class="image" src="../../assets/renew_pc/p-image-2.png" alt="재진률 80% 2)"/>
                    <img class="text-image" src="../../assets/renew_pc/t2.png" alt="재진률 80% 2)"/>
                </div>
                <div class="img-wrapper3">
                    <img class="image" src="../../assets/renew_pc/p-image-3.png" alt="누적 이용자 수 500,000+ 2)"/>
                    <img class="text-image" src="../../assets/renew_pc/t3.png" alt="누적 이용자 수 500,000+ 2)"/>
                </div>            
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'proof',
    data: function()
    {
        return {
            flag: false
        }
    },
    mounted: function()
    {
        let _this = this;
        $(window).scroll(function () {
            var elementHeight = window.innerHeight ;
            var height = $(document).scrollTop();
            if(height < elementHeight*10)
            {
                _this.flag = false;
				$('.proof .title').css('display', `none`);
                $('.proof .sub-title').css('display', `none`);
				$('.img-wrapper1').css('display', `none`);
                $('.img-wrapper2').css('display', `none`);
                $('.img-wrapper3').css('display', `none`);
            }
            else if(height > elementHeight*10 && height <= elementHeight*10.5)
            {
                $('.proof .title').css('display', `flex`);
                $('.proof .sub-title').css('display', `flex`);
            }
            else if(height >= elementHeight*10.5 && height < elementHeight*12)
            {
                // $('.proof .title').css('display', `flex`);
                // $('.proof .sub-title').css('display', `flex`);
                $('.img-wrapper1').css('display', `flex`);
                $('.img-wrapper2').css('display', `flex`);
                $('.img-wrapper3').css('display', `flex`);
            }
            // else if(height >= elementHeight*12)
            // {
            //     $('.proof .title').css('display', `flex`);
            //     $('.proof .sub-title').css('display', `flex`);
            //     $('.img-wrapper1').css('display', `flex`);
            //     $('.img-wrapper2').css('display', `flex`);
            //     $('.img-wrapper3').css('display', `flex`);
            // }         
        })
    }
}
</script>

<style scoped>
    .proof {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 100%;
        height: 1035px;
        background: #fff;
    }
    .inner-div-proof{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 1200px;
        height: 100%;
        margin-bottom: 10px;
        padding-top: 255px;
        /* transition: all 2s; */
    }
    .title {
        font-weight: 600;
        font-size: 44px;
        line-height: 62px;       
        text-align: center;
        color: #1A1A1A;
        animation: fadeInUp 1s;
        display: none;

    }
    .sub-title {
        font-weight: 400;
        font-size: 16px;
        line-height: 32px;
        color: #666;
        margin-top: 16px;
        animation: fadeInUp2 1.5s;
        display: none;
    }
	.sub-title span + span{
		margin-left: 8px;
	}
    .img-list {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 76px;
    }
    .img-wrapper1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        animation: fadeInUp 1s;
        display: none;
    }
     .img-wrapper2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        animation: fadeInUp 1s;
        display: none;
    }
     .img-wrapper3 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        animation: fadeInUp 1s;
        display: none;
    }
    .image {
        width: 400px;
        height: 274px;
    }
    .text-image {
        margin-top: 31px;
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
         
        }
        to {
            opacity: 1;

        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 150%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_main/Proof.vue